// extracted by mini-css-extract-plugin
export default {"admin-container":"Admin_admin-container__C12io","admin-content":"Admin_admin-content__V1zIG","selection-container":"Admin_selection-container__7irVJ"};